import { ApolloClient, InMemoryCache } from '@apollo/client';
import { API_URL } from '../../environments/config';

const getDeviceType = () => {
  if (typeof window !== 'undefined' && window.orientation === undefined) {
    return 'desktop';
  }
  return 'mweb';
};

export const client = new ApolloClient({
  uri: API_URL,
  cache: new InMemoryCache(),
  credentials: 'omit',
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'none',
    },
    query: {
      errorPolicy: 'none',
    },
    mutate: {
      errorPolicy: 'none',
    },
  },
  headers: {
    device: getDeviceType(),
    tenantId: '1',
    'x-auth-secret': '3KXckAwvSvZQJCuztvw846AqFY465Yxd',
    merchantId: 'D11',
  },
});
